import JotformEmbed from "react-jotform-embed";
import PropTypes from "prop-types";

function JotFormWrapper({ jotFormID }) {

    const isEnabled = process.env.REACT_APP_JOTFORM_ENABLED === "true";

    return (
        <div>
            {isEnabled
                ?
                <JotformEmbed src={`https://form.jotform.com/${jotFormID}`}
                />
                :
                null
            }
        </div>
    );
}

JotFormWrapper.propTypes = {
    jotFormID: PropTypes.string.isRequired,
};

export default JotFormWrapper;